import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Article, ArticleAccessory, ViewModeType } from '@lobos/library';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreakpointService } from '../../../../services/ui/breakpoint.service';

@UntilDestroy()
@Component({
  selector: 'app-accessory-list',
  templateUrl: './accessory-list.component.html',
  styleUrls: ['./accessory-list.component.scss'],
})
export class AccessoryListComponent implements OnChanges {
  @Input() articleAccessory: ArticleAccessory | undefined | null;

  @Output() alternativeArticleSelected: EventEmitter<Article> = new EventEmitter<Article>();

  public viewMode: ViewModeType = 'list';
  public isTablet = true;

  constructor(private breakpointService: BreakpointService) {
    this.breakpointService.tablet.pipe(untilDestroyed(this)).subscribe((isTablet: boolean) => {
      this.isTablet = isTablet;
      if (isTablet) {
        this.viewMode = 'grid';
      } else {
        this.viewMode = 'list';
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // this sorts the accessory articles alphabetically based on the key property
    if (changes['articleAccessory']) {
      this.articleAccessory?.accessories.sort((a, b) => (a.key > b.key ? 1 : b.key > a.key ? -1 : 0));
    }
  }

  changeViewMode(viewMode: ViewModeType) {
    this.viewMode = viewMode;
  }

  selectAlternativeArticle(article: Article) {
    this.alternativeArticleSelected.emit(article);
  }
}
